import CodeMirror from 'utils/codemirror';

export default class MarkdownElement {
  constructor(options) {
    this.templates = {
      "add_markdown": "<a id='add-build-markdown' class='button secondary editor-add-markdown' href=''><i class='fa fa-shopping-bag'></i> markdown</a>",
      "markdown_editor":  "<div class='row-fluid editor-add-markdown-wrapper'>" +
                          "<textarea id='markdown-code-editor' class='build-textarea editor-add-markdown-content span12' style='display=block;' value='Enter a Title'></textarea>" +
                          "<div class='editor-buttons'>" +
                            "<button class='editor-add-markdown-delete delete'>Delete</button>" +
                            "<button class='editor-add-markdown-cancel cancel'>Cancel</button>" +
                            "<button class='editor-add-markdown-submit save'>Save</button>" +
                          "</div>" +
                          "<div class='clearfix'></div>" +
                        "</div>",
      "markdown_element": "<div class='element markdown-element build-markdown'>" +
                            "<pre class='markdown-raw'></pre>" +
                            "<div class='markdown-html'></div>" +
                          "</div>",
      "markdown_error": "<div class='markdown-error alert alert-danger'></div>"
    }
    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;

    this.editor_enabled = false;
    this.code_editor;

    //used when editing markdown to restore previous state on cancel
    this.saved_markdown;
    this.saved_html;
    this.activeElementId;
    this.activePosition;
    this.init_markdown();
  }

  /* listens for the "Markdown" button click, and adds the markdown editor. */
  init_markdown() {
    $(document).on('click', '.add-build-markdown', $.proxy(this.append_markdown, this));
    $(document).on('click', '.build-markdown', $.proxy(this.edit_existing_markdown, this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-markdown" href="#"><i class="fa fa-align-justify"></i>Markdown</a>';
  }

  append_markdown(event, $element, markdown) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    if(!$element) {
      $element = $(event.target).closest('.button-bar, .bottom-button-bar');
    }

    $element.hide();

    var $markdown_editor = $(this.templates.markdown_editor).hide();
    $element.replaceWith($markdown_editor);

    if (markdown) {
      $('#markdown-code-editor', $markdown_editor).val(markdown);
    }

    $markdown_editor.show();

    this.markdown_enable_code_editor('markdown-code-editor', true);
    this.learnEditor.center_in_view($markdown_editor);
    this.learnEditor.editing();
    this.enable_markdown_editor();
  }

  edit_existing_markdown(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.activeElementId = $(event.currentTarget).attr('id');
    this.activePosition = $(event.currentTarget).data('position');
    this.saved_markdown = $('.markdown-raw', $(event.currentTarget)).text();
    this.saved_html = $('.markdown-html', $(event.currentTarget)).html();

    this.append_markdown(event, $(event.currentTarget), this.saved_markdown);
  }

  enable_markdown_editor() {
    $('.editor-add-markdown-wrapper').on('click', '.editor-add-markdown-submit', $.proxy(this.save_markdown_handler, this));
    $('.editor-add-markdown-wrapper').on('click', '.editor-add-markdown-cancel', $.proxy(this.cancel_markdown_handler, this));
    $('.editor-add-markdown-wrapper').on('click', '.editor-add-markdown-delete', $.proxy(this.delete_markdown_handler, this));
  }

  markdown_enable_code_editor(element) {
      CodeMirror.modeURL = "/codemirror/mode/%N/%N.js";
      this.code_editor = CodeMirror.fromTextArea(document.getElementById(element), {
        inputStyle: "contenteditable",
        spellcheck: true,
        lineNumbers: false,
        matchBrackets: true,
        lineWrapping: true,
        theme: 'base16-light',
        extraKeys: {"Enter": "newlineAndIndentContinueMarkdownList"}
      });
      this.code_editor.setOption("mode", "gfm");
      CodeMirror.autoLoadMode(this.code_editor, "gfm");
  }

  markdown_editor_modified() {
    $(document).off('click', '.editor-add-markdown-submit');
    $(document).off('click', '.editor-add-markdown-cancel');
    $(document).off('click', '.editor-add-markdown-delete');

    this.saved_markdown = null;
    this.saved_html = null;
    this.learnEditor.save_page("Before markdown Modified");
  }

  save_markdown_handler(event) {
    event.preventDefault();

    this.create_markdown_element();
  }

  cancel_markdown_handler(event) {
    event.preventDefault();

    var $markdown_element = this.renderMarkdownElement();

    $('.markdown-raw', $markdown_element).text(this.saved_markdown);
    $('.markdown-html', $markdown_element).html(this.saved_html);

    if (this.saved_html) {
      $('.editor-add-markdown-wrapper').replaceWith($markdown_element);
    } else {
      $('.editor-add-markdown-wrapper').remove();
    }

    this.learnEditor.finishEditing();
  }

  delete_markdown_handler(event) {
    event.preventDefault();

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.activeElementId = "";
    this.activePosition = "";
    $(event.currentTarget).closest('.editor-add-markdown-wrapper').remove();
    this.markdown_editor_modified();
  }

  create_markdown_element() {
    var $markdown_element = this.renderMarkdownElement();

    var content = this.code_editor.getValue();
    $('.markdown-raw', $markdown_element).text(content);
    // remove any existing errors
    $('.markdown-error').remove();

    var that = this;
    $.post('/elements/markdown.json', { markdown: content}, function(response) {
      $('.markdown-html', $markdown_element).html(response.content);
      $('.editor-add-markdown-wrapper').replaceWith($markdown_element);
      that.markdown_editor_modified();
    }).fail(function(xhr) {
      var response = xhr.responseJSON;
      var error = response.error;

      if (xhr.status !== 422) {
        error = "There was an error saving, please try again.";
      }

      var template = $(this.templates.markdown_error).html(error);
      $('.editor-add-markdown-wrapper').prepend(template);
    });
  }

  renderMarkdownElement() {
    var template = $(this.templates.markdown_element).attr('id', (this.activeElementId || "")).data('position', this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    return template;
  }
}
